module.exports = __webpack_public_path__ + "img/i.28172e6a.jpg";